/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Mcp_Access_Setup_HintInputs */



/**
* | output |
* | --- |
* | "Add this to your client's MCP settings and replace YOUR_API_KEY with a personal API key." |
*
* @param {My_Integrations_Mcp_Access_Setup_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_mcp_access_setup_hint = /** @type {((inputs?: My_Integrations_Mcp_Access_Setup_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Mcp_Access_Setup_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie dies in die MCP-Einstellungen Ihres Clients ein und ersetzen Sie YOUR_API_KEY durch einen persönlichen API-Schlüssel.")
	return /** @type {LocalizedString} */ ("Add this to your client's MCP settings and replace YOUR_API_KEY with a personal API key.")
});